
import { Component, Vue } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
import { PostLogin } from "@/request/common";
import Remember from "../components/remember.vue";
import { Md5 } from "ts-md5";
@Component({
  components: {
    Remember,
  },
})
export default class Login extends Vue {
  private type: any = "text";
  private ifRember: any = true;
  private visible: any = false;
  private window: any = window;
  private loginInfo: any = {
    用户名: "",
    密码: "",
  };

  private paws: any = [];
  private showPassword: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private changeEye(val: any) {
    this.showPassword = val;
    if (val) {
      this.type = "text";
    } else {
      this.type = "password";
    }
  }
  private pawInput(e: any) {
    if (this.loginInfo["密码"] && !this.showPassword) {
      this.type = "password";
    } else {
      this.type = "text";
    }
  }
  private focus() {
    if (localStorage.getItem("cepingpaws")) {
      this.paws = JSON.parse(localStorage.getItem("cepingpaws") || "");
    }
  }
  private update(e: any) {
    this.type = "password";
    this.loginInfo["用户名"] = e.name;
    this.loginInfo["密码"] = e.paw;
    this.visible = false;
  }
  private delPaw(e: any) {
    if (e.length == 0) {
      this.type = "text";
    }
    this.paws = JSON.parse(JSON.stringify(e));
  }
  /**
   * @description 登录
   */
  private login(): void {
    if (!this.loginInfo["用户名"]) {
      this.$message.warning("请输入用户名");
      return;
    }
    if (!this.loginInfo["密码"]) {
      this.$message.warning("请输入密码");
      return;
    }
    const params: any = {
      username: this.loginInfo["用户名"],
      password: Md5.hashStr(this.loginInfo["密码"]),
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostLogin(this, params, loading)
      .then((res: any) => {
        loading.close();
        const d = res.data;
        const token = d.access;
        const user = d;
        this.$store.commit("updateToken", token);
        this.$store.commit("updateUser", user);
        if (this.ifRember) {
          // 如果没有存过则储存，如果已经储存过则更新
          if (this.paws.length === 0) {
            this.paws.push({
              name: this.loginInfo["用户名"],
              paw: this.loginInfo["密码"],
            });
          } else {
            let ifRepeat: any = false;
            let i: any = "";
            this.paws.forEach((ele: any, index: any) => {
              if (ele.name == this.loginInfo["用户名"]) {
                i = index;
                ifRepeat = true;
              }
            });
            if (ifRepeat) {
              this.paws.splice(i, 1);
            }
            this.paws.push({
              name: this.loginInfo["用户名"],
              paw: this.loginInfo["密码"],
            });
          }
        }
        localStorage.setItem("cepingpaws", JSON.stringify(this.paws));
        this.goPage();
      })
      .catch(() => {
        loading.close();
      });
  }
  private goPage() {
    clearFilter();
    this.$router.push("/main/manage/tem-list");
  }
  private mounted() {
    if (localStorage.getItem("cepingpaws")) {
      this.paws = JSON.parse(localStorage.getItem("cepingpaws") || "");
    }
  }
}
